import axios from 'axios';
import store from '../store'
import router from "../router";

class UsersRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    getUser() {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/account`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    async getAllUsersPaginated(page, size, email = '', login = '') {
        const headers = { 'Authorization': store.state.token };
        const params = { page, size, email, login };
        const response = await axios.get(`${this.basePath}/ext/user-details/all-paginated`, { headers, params });
        if (response.status === 401) {
          store.commit('clearData');
          router.push('/');
        }
        return response;
      }      

    getUserByUsername(username) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/users/${username}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    getUserDetails(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/user-details/user/${userId}`, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    changeProExpirationDate(newProTime) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/edit-pro`, newProTime, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }

    sendEmail(emailNeeds) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ext/users/email/send`, emailNeeds, {headers: headers});
        response.catch((error) => { if(error.response.status === 401) { store.commit('clearData'); router.push('/'); } });  // Go to login to re-authenticate
        return response;
    }
}

export default new UsersRepository();
